import { mapObjectToQueryParams } from '@/helpers/formatArrayParams';
import { getLocalStorageData, localStorageKeys, updateLocalStorageData } from '@/helpers/localStorageHelpers';
import { add, append, set, update } from '@/vuex/helpers';

const defaultFilters = {
  search: '',
  client_company: [],
  assigned_to: [],
  status: [],
  permit_status: [],
  permit_obtained: '',
  page: 1,
  page_size: 10,
  order_by: 'fullname',
  include_family: 1,
  case_assessment: 0,
};

export default {
  namespaced: true,
  state: {
    isLoading: false,
    foreigners: [],
    allForeignersSimple: [],
    filters: getLocalStorageData(localStorageKeys.foreigners, defaultFilters),
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
        updateLocalStorageData(localStorageKeys.foreigners, { ...state.filters, page: 1 });
      }
    },
    resetFilters(state) {
      state.filters = { ...defaultFilters, page_size: state.filters.page_size };
      updateLocalStorageData(localStorageKeys.foreigners, state.filters);
    },
  },
  actions: {
    async addForeigner({ commit }, { payload }) {
      const foreigner = await this.$axios.$post('/api/foreigner/', payload);

      commit('add', ['foreigners', foreigner]);
    },

    async loadForeigners({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get('/api/foreigner/', {
        params: {
          ...mapObjectToQueryParams(state.filters),
        },
      });

      commit('set', ['foreigners', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },

    async loadAllForeignersSimple({ commit }) {
      const response = await this.$axios.get('/api/foreigner/simple/?page=1&page_size=-1&order_by=fullname');

      commit('set', ['allForeignersSimple', response.data.data]);
    },

    async exportForeigners({ state }) {
      const response = await this.$axios.get('/api/foreigner/export/xlsx/', {
        params: {
          ...mapObjectToQueryParams(state.filters),
        },
        responseType: 'blob',
      });

      return response;
    },
  },
  getters: {
    someFilterIsSelected: (state) => {
      return state.filters.search !== defaultFilters.search
      || state.filters.client_company.length !== defaultFilters.client_company.length
      || state.filters.assigned_to.length !== defaultFilters.assigned_to.length
      || state.filters.status.length !== defaultFilters.status.length
      || state.filters.permit_status.length !== defaultFilters.permit_status.length
      || state.filters.permit_obtained !== defaultFilters.permit_obtained
      || state.filters.include_family !== defaultFilters.include_family
      || state.filters.case_assessment !== defaultFilters.case_assessment
      || state.filters.order_by !== defaultFilters.order_by;
    },
  },
};
